var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMsgFolderWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMsgFolder@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.98439024,11.6 L12.1970732,11.6 C13.8653659,11.6 15.2,10.3150769 15.2,8.72676923 L15.2,2.87323077 C15.2,1.28492308 13.8653659,0 12.2156098,0 L2.98439024,0 C1.33463415,0 0,1.28492308 0,2.87323077 L0,8.70892308 C0,10.3150769 1.33463415,11.6 2.98439024,11.6 Z M12.2156098,10.8861538 L2.98439024,10.8861538 C2.00195122,10.8861538 1.16780488,10.2793846 0.871219512,9.44061538 L5.13463415,5.71076923 L5.39414634,5.94276923 C6.04292683,6.496 6.82146341,6.78153846 7.6,6.78153846 C8.37853659,6.78153846 9.15707317,6.51384615 9.78731707,5.96061538 L10.0468293,5.72861538 L14.3102439,9.45846154 C14.0136585,10.2793846 13.1795122,10.8861538 12.2156098,10.8861538 Z M0.926829268,2.01661538 L4.59707317,5.22892308 L0.741463415,8.584 L0.741463415,2.87323077 C0.741463415,2.56984615 0.815609756,2.28430769 0.926829268,2.01661538 Z M14.4585366,2.87323077 L14.4585366,8.584 L10.6214634,5.22892308 L14.2731707,2.03446154 C14.4029268,2.28430769 14.4585366,2.58769231 14.4585366,2.87323077 Z M2.98439024,0.713846154 L12.1970732,0.713846154 C12.8643902,0.713846154 13.4390244,0.981538462 13.8653659,1.42769231 L9.30536585,5.40738462 C8.32292683,6.264 6.89560976,6.264 5.91317073,5.40738462 L1.33463415,1.42769231 C1.74243902,0.981538462 2.33560976,0.713846154 2.98439024,0.713846154 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter_Inbox-folder",
    transform: "translate(-19.000000, -381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accept-video-chat-from-Copy-5",
    transform: "translate(0.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(19.400000, 39.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icMsgFolder",
    fill: "#fff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsgFolderWhite);
export default __webpack_public_path__ + "static/media/icMsgFolderWhite.2bb9de13f3a47e62d321dbce1e62072b.svg";
export { ForwardRef as ReactComponent };